import Vue from 'vue';

const success = (data, context, paymentIndex) => {
  toastr.success(data.msg);
  if (paymentIndex == null) {
    context.get_payments();
  } else {
    context.paymentItem = {
      histories: [],
    };
    context.hostPayoutFee.splice(paymentIndex, 1);
  }
  context.smallLoading = false;
  context.closeModal ('#cancel-payment-modal');
};

const failed = (context, error) => {
  context.showToasterError(error);
  context.smallLoading = false;
};

export default (context, paymentId, paymentIndex = null) => Vue.$http.delete(`payments/${paymentId}`)
  .then((response) => {
    if (response && response.status === 200) {
      success(response.data, context, paymentIndex);
    }
  })
  .catch((error) => {
    failed(context, error);
  });



// WEBPACK FOOTER //
// ./src/app/services/payment/cancelPayment.js